import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSearchParams } from 'react-router-dom';
import { AdminChatList } from '../components/chat/AdminChatList';
import { AdminChatWindow } from '../components/chat/AdminChatWindow';

const Page = styled.div`
  background: var(--background);
  padding: 1.5rem;
  height: calc(95vh - 64px - 3rem); /* header + page padding */
  overflow: hidden;
`;

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  background: var(--surface);
  border: 1px solid var(--outline);
  border-radius: 14px;
  box-shadow: 0 12px 24px rgba(17, 24, 39, 0.06);
  overflow: hidden;
`;

export default function UsersMessagesPage() {
  const [selected, setSelected] = useState<string | null>(null);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const recipient = searchParams.get('recipient');
    if (recipient) {
      setSelected(recipient);
    }
  }, [searchParams]);

  return (
    <Page>
      <Wrapper>
        <AdminChatList
          selectedId={selected}
          onSelect={setSelected}
          includeUserIds={selected ? [selected] : []}
        />
        <AdminChatWindow otherUserId={selected} />
      </Wrapper>
    </Page>
  );
}
